<template>
    <div>
        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px">
                <strong style="font-size: 25px">Pelatihan</strong>
            </a-col>
            <a-col flex="0 1 300px">
                <a-button type="primary" icon="plus" block @click="showModal('')">
                Tambah
                </a-button>
            </a-col>
        </a-row>

        <a-card type="inner" size="small" >
            <a-form-model :form="form" :model="formData" labelAlign="left">
            <a-skeleton :loading="loading" active>
                <a-table
                    class="pcp-table"
                    :columns="columns"
                    :dataSource="items.data"
                    rowKey="hash"
                    :pagination="false"
                    bordered>

                    <div slot="title" slot-scope="record" class="text-small text-left">
                        <a-input
                            v-if="editable.key == record.hash"
                            v-model="formDataTraining.title"
                        />
                        <div v-else>
                            {{ record.title }}
                        </div>
                    </div>   

                    <div slot="description" slot-scope="record" class="text-small text-left">
                        <a-input
                            v-if="editable.key == record.hash"
                            v-model="formDataTraining.description"
                        />
                        <div v-else>
                            {{ record.description }}
                        </div>
                    </div>   

                    <div slot="date_start" slot-scope="record" class="text-small text-center">
                        <a-date-picker
                            v-if="editable.key == record.hash"
                            v-model="formDataTraining.date_start"
                            @change="onStartDateTrainingChange"
                            :format="'YYYY-MM-DD'"
                            :valueFormat="'YYYY-MM-DD'"
                            type="date"
                            placeholder="Pick a date"
                        />
                        <div v-else>
                            <template v-if="record.date_start != null">
                                {{ moment(record.date_start).format('DD-MM-YYYY') }}
                            </template>
                        </div>
                    </div>  

                    <div slot="date_end" slot-scope="record" class="text-small text-center">
                        <a-date-picker
                            v-if="editable.key == record.hash"
                            v-model="formDataTraining.date_end"
                            @change="onEndDateTrainingChange"
                            :format="'YYYY-MM-DD'"
                            :valueFormat="'YYYY-MM-DD'"
                            type="date"
                            placeholder="Pick a date"
                        />
                        <div v-else>
                            <template v-if="record.date_end != null">
                                {{ moment(record.date_end).format('DD-MM-YYYY') }}
                            </template>
                        </div>
                    </div>      

                    <div slot="domain" slot-scope="record" class="text-small text-left">
                        <a-input
                            v-if="editable.key == record.hash"
                            v-model="formDataTraining.domain"
                        />
                        <div v-else>
                            {{ record.domain }}
                        </div>
                    </div>          

                    <div slot="location" slot-scope="record" class="text-small text-left">
                        <a-input
                            v-if="editable.key == record.hash"
                            v-model="formDataTraining.location"
                        />
                        <div v-else>
                            {{ record.location }}
                        </div>
                    </div>           

                    <div slot="updated_at" slot-scope="record" class="text-small text-center">
                        <template v-if="record.updated_at != null">
                            {{ moment(record.updated_at).format('DD-MM-YYYY HH:mm:ss') }}
                        </template>
                    </div>

                    <div slot="action" slot-scope="record" style="text-align: center">
                        <div v-if="editable.key == record.hash">
                            <a-button type="link" @click="(e) => saveTraining(e, record)" :loading="saving">
                                Save
                            </a-button>
                            <!--<a-button type="link" @click="(e) => showConfirmDeleteTraining(e, record)" :loading="saving">
                                Delete
                            </a-button>-->
                            <a-button type="link" @click="(e) => cancel()" :loading="saving">
                                Cancel
                            </a-button>
                        </div>
                        
                        <a-button type="link" @click="editTraining(record)" :disabled="editable.key != ''" v-else>
                            Edit
                        </a-button>
                    </div>

                    <p slot="expandedRowRender" slot-scope="record" style="text-align: right;margin: 0">
                        <a-button type="primary" icon="plus" @click="showModalKelas(record.hash, '')">Tambah Kelas Klasikal</a-button>

                        <a-table
                            class="pcp-table"
                            :columns="innerClassColumns"
                            rowKey="id"
                            style="margin: 12px"
                            :data-source="record.classes"
                            :pagination="false"
                        >
                            <div slot="className" slot-scope="innerRecord" class="text-small text-left">
                                <a-input
                                    v-if="editable.key == innerRecord.id"
                                    v-model="formDataClass.name"
                                />
                                <div v-else>
                                    {{ innerRecord.name }}
                                </div>
                            </div>

                            <div slot="action" slot-scope="innerRecord" class="text-small text-center">
                                <div v-if="editable.key == innerRecord.id">
                                    <a-button type="link" @click="(e) => saveClass(e, innerRecord)" :loading="saving">
                                        Save
                                    </a-button>
                                    <!--<a-button type="link" @click="(e) => showConfirmDelete(e, innerRecord)" :loading="saving">
                                        Delete
                                    </a-button>-->
                                    <a-button type="link" @click="(e) => cancel()" :loading="saving">
                                        Cancel
                                    </a-button>
                                </div>
                                
                                <a-button type="link" @click="editClass(innerRecord)" :disabled="editable.key != ''" v-else>
                                    Edit
                                </a-button>
                            </div>  

                        </a-table>

                        <a-button type="primary" icon="plus" @click="showModalModule(record.hash, '')">Tambah Modul</a-button>

                        <a-table
                            class="pcp-table"
                            :columns="innerColumns"
                            rowKey="hash"
                            style="margin: 12px"
                            :data-source="record.modules"
                            :pagination="false"
                        >
                            <div slot="module" slot-scope="innerRecord" class="text-small text-left">
                                {{ innerRecord.module.labels.title }}
                            </div>   

                            <div slot="date_start" slot-scope="innerRecord">
                                <a-date-picker
                                    v-if="editable.key == innerRecord.hash"
                                    v-model="formData.date_start"
                                    @change="onStartDateChange"
                                    :format="'YYYY-MM-DD'"
                                    :valueFormat="'YYYY-MM-DD'"
                                    type="date"
                                    placeholder="Pick a date"
                                />
                                <div v-else class="text-small text-center">
                                    <template v-if="innerRecord.date_start != null">
                                        {{ moment(innerRecord.date_start).format('DD-MM-YYYY') }}
                                    </template>
                                </div>
                            </div>  

                            <div slot="date_end" slot-scope="innerRecord">
                                <a-date-picker
                                    v-if="editable.key == innerRecord.hash"
                                    v-model="formData.date_end"
                                    @change="onEndDateChange"
                                    :format="'YYYY-MM-DD'"
                                    :valueFormat="'YYYY-MM-DD'"
                                    type="date"
                                    placeholder="Pick a date"
                                />
                                <div v-else class="text-small text-center">
                                    <template v-if="innerRecord.date_end != null">
                                        {{ moment(innerRecord.date_end).format('DD-MM-YYYY') }}
                                    </template>
                                </div>
                            </div>      

                            <div slot="weight" slot-scope="innerRecord" class="text-small text-center">
                                <a-input-number
                                    v-if="editable.key == innerRecord.hash"
                                    v-model="formData.weight"
                                />
                                <div v-else>
                                    {{ (innerRecord.weight*100) }}
                                </div>
                            </div> 

                            <div slot="is_shown" slot-scope="innerRecord" class="text-small text-center">
                                <a-checkbox @change="onChange"
                                    v-if="editable.key == innerRecord.hash"
                                    v-model="formData.is_shown"
                                />
                                <a-checkbox v-else
                                    :checked="innerRecord.is_shown" disabled
                                />
                            </div> 

                            <div slot="action" slot-scope="innerRecord" class="text-small text-center">
                                <div v-if="editable.key == innerRecord.hash">
                                    <a-button type="link" @click="(e) => save(e, innerRecord)" :loading="saving">
                                        Save
                                    </a-button>
                                    <!--<a-button type="link" @click="(e) => showConfirmDelete(e, innerRecord)" :loading="saving">
                                        Delete
                                    </a-button>-->
                                    <a-button type="link" @click="(e) => cancel()" :loading="saving">
                                        Cancel
                                    </a-button>
                                </div>
                                
                                <a-button type="link" @click="edit(innerRecord)" :disabled="editable.key != ''" v-else>
                                    Edit
                                </a-button>
                            </div>  
                        </a-table>
                    </p>

                    
                </a-table>
            </a-skeleton>
            </a-form-model>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
            width="90%"
        >
            <admin-setting-training-form
                :bank="hash"
                :hash="id"
                @handleClose="closeModal"
            />
        </a-modal>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visibleKelas"
            :closable="false"
        >
            <admin-setting-class-form
                :training="training"
                :hash="id"
                @handleClose="closeModal"
            />
        </a-modal>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visibleModule"
            :closable="false"
        >
            <admin-setting-training-module-form
                :training="training"
                :hash="id"
                @handleClose="closeModal"
            />
        </a-modal>
    </div>
</template>

<script>

const columns = [
    {
		key: 'title',
		title: 'Judul Pelatihan',
        align: 'center',
		scopedSlots: {customRender: 'title'},
	}, {
        key: 'description',
        title: 'Deskripsi',
        align: 'center',
        scopedSlots: {customRender: 'description'},
    }, {
		key: 'date_start',
		title: 'Tanggal Mulai',
        align: 'center',
		scopedSlots: {customRender: 'date_start'}
	}, {
		key: 'date_end',
		title: 'Tanggal Berakhir',
        align: 'center',
		scopedSlots: {customRender: 'date_end'}
	}, {
		key: 'domain',
		title: 'Domain',
        align: 'center',
		scopedSlots: {customRender: 'domain'}
	}, {
		key: 'location',
		title: 'Lokasi',
        align: 'center',
		scopedSlots: {customRender: 'location'}
	}, {
        key: 'updated_at',
        title: 'Last Update',
        align: 'center',
        scopedSlots: {customRender: 'updated_at'}
    }, {
		key: 'action',
		title: 'Action',
		align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]

const innerColumns = [
    {
		key: 'module',
		title: 'Module',
        align: 'center',
		scopedSlots: {customRender: 'module'},
	}, {
		key: 'date_start',
		title: 'Tanggal Mulai',
        align: 'center',
		scopedSlots: {customRender: 'date_start'}
	}, {
		key: 'date_end',
		title: 'Tanggal Berakhir',
        align: 'center',
		scopedSlots: {customRender: 'date_end'}
	}, {
		key: 'weight',
		title: 'Bobot (%)',
        align: 'center',
		scopedSlots: {customRender: 'weight'}
	}, {
		key: 'is_shown',
		title: 'Tampil Menu',
        align: 'center',
		scopedSlots: {customRender: 'is_shown'}
	}, {
		key: 'action',
		title: 'Action',
		align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]

const innerClassColumns = [
    {
		key: 'className',
		title: 'Kelas Klasikal',
        align: 'center',
		scopedSlots: {customRender: 'className'},
	}, {
		key: 'action',
		title: 'Action',
		align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]

export default {
    props: {
        hash: {
            required: true
        }
    },
    data() {
        return {
            columns,
            innerColumns,
            innerClassColumns,
            loading: false,
            saving: false,
            items: {
                data: []
            },
            filters: {
                q: null,
                bank: this.hash
            },
            id: null,
            training: null,
            visible: false,
            visibleKelas: false,
            visibleModule: false,
            form: this.$form.createForm(this),
            formData: {
                weight: '',
                date_start: '',
                date_end: '',
                is_shown: true
            },
            formDataTraining: {
                title: '',
                description: '',
                date_start: '',
                date_end: ''
            },
            formDataClass: {
                name: '',
            },
            editable: {
                key: ''
            }
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri('api.trainings'), {
                    params: this.filters
                })
                .then(response => this.items = response.data.trainings)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        showModal(hash) {
            this.id = hash;
            this.visible = true;
        },
        showModalKelas(training, hash) {
            this.id = hash;
            this.training = training
            this.visibleKelas = true;
        },
        showModalModule(training, hash) {
            this.id = hash;
            this.training = training
            this.visibleModule = true;
        },
        closeModal(isRefresh) {
            this.visible = false;
            this.visibleKelas = false;
            this.visibleModule = false

            if (isRefresh == true) {
                this.getItems();
            }
        },
        edit(record) {
            this.formData.title = record.title
            this.formData.is_shown = record.is_shown
            this.formData.weight = record.weight*100
            this.formData.date_start = this.moment(record.date_start).format('YYYY-MM-DD')
            this.formData.date_end = this.moment(record.date_end).format('YYYY-MM-DD')
            this.editable.key = record.hash
        },
        editTraining(record) {
            this.formDataTraining.title = record.title
            this.formDataTraining.description = record.description
            this.formDataTraining.date_start = this.moment(record.date_start).format('YYYY-MM-DD')
            this.formDataTraining.date_end = this.moment(record.date_end).format('YYYY-MM-DD')
            this.formDataTraining.domain = record.domain
            this.formDataTraining.location = record.location
            this.editable.key = record.hash
        },
        editClass(record) {
            this.formDataClass.name = record.name
            this.editable.key = record.id
        },
        cancel(){
            this.editable.key = ''
            this.formData.weight = ''
            this.formData.is_shown = ''
            this.formData.date_start = ''
            this.formData.date_end = ''
            this.formDataTraining.title = ''
            this.formDataTraining.description = ''
            this.formDataTraining.domain = ''
            this.formDataTraining.location = ''
            this.formDataTraining.date_start = ''
            this.formDataTraining.date_end = ''
        },
        save(e, record) {
            e.preventDefault(e);

            this.saving = true;

            let promise;

            this.formData.module = record.module.identifier

            promise = this.$http.put(
                this.routeUri("api.training-modules.update", {module: record.hash}),
                this.formData
            );
            
            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.saving = false));
        },
        saveTraining(e, record) {
            e.preventDefault(e);

            this.saving = true;

            let promise;

            promise = this.$http.put(
                this.routeUri("api.trainings.update", {training: record.hash}),
                this.formDataTraining
            );
            
            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.saving = false));
        },
        saveClass(e, record) {
            e.preventDefault(e);

            this.saving = true;

            let promise;

            promise = this.$http.put(
                this.routeUri("api.training-classes.update", {class: record.id}),
                this.formDataClass
            );
            
            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.saving = false));
        },
        deleteModule(e, record) {
            e.preventDefault(e);

            this.saving = true;

            let promise;

            this.formData.module = record.module.identifier

            promise = this.$http.delete(
                this.routeUri("api.training-modules.destroy", {module: record.hash}),
                this.formData
            );
            
            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.saving = false));
        },
        deleteTraining(e, record) {
            e.preventDefault(e);

            this.saving = true;

            let promise;

            promise = this.$http.delete(
                this.routeUri("api.trainings.destroy", {training: record.hash}),
                this.formDataTraining
            );
            
            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.saving = false));
        },
        showConfirmDelete(e, record) {
            var msg = 'Anda yakin akan melakukan hapus data?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.deleteModule(e, record)
                },
                onCancel() {},
                class: 'test',
            });
        },
        showConfirmDeleteTraining(e, record) {
            var msg = 'Anda yakin akan melakukan hapus data?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.deleteTraining(e, record)
                },
                onCancel() {},
                class: 'test',
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            window.location.reload()
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        onStartDateChange(date, dateString) {
            this.formData.date_start = dateString
        },
        onEndDateChange(date, dateString) {
            this.formData.date_end = dateString
        },
        onStartDateTrainingChange(date, dateString) {
            this.formDataTraining.date_start = dateString
        },
        onEndDateTrainingChange(date, dateString) {
            this.formDataTraining.date_end = dateString
        },
        onChange(e) {
            this.formData.is_shown = e.target.checked

        },
    },
}
</script>
